import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import type { GetInputs, UnwrapInput } from '@core/common-legacy';
import { componentOutletConfigFactory } from '@core/common-legacy';

import { TagComponent } from '../../../common/tag/tag.component';
import type { DataTableRow, TableCellFactory } from '../../data-table.types';
import { EMPTY_CELL } from '../text-cell.component';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
*/

@Component({
  imports: [TagComponent],
  template: `
    @for (tag of tags(); track tag) {
      <rt-tag [isHoverable]="isHoverable()" [name]="tag" [disabled]="disabled()" />
    }
  `,
  styleUrls: ['./tags-cell.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class]': '"tags-list"',
  },
})
export class TagsCellComponent {
  public static NgInputs = ['tags' as const, 'disabled' as const, 'isHoverable' as const];

  public tags = input<Array<UnwrapInput<TagComponent['name']>>>([]);
  public disabled: TagComponent['disabled'] = input(false);
  public isHoverable: TagComponent['isHoverable'] = input(true);
}

export const tagsCellFactory =
  <Key extends keyof Row, Row extends DataTableRow & { [k in Key]: string[] }>(
    key: Key,
    inputs: Omit<GetInputs<typeof TagsCellComponent>, 'tags'>,
  ): TableCellFactory<Row> =>
  ({ row }) => {
    if (!row[key]?.length) return EMPTY_CELL;

    return componentOutletConfigFactory(TagsCellComponent, {
      inputs: { tags: row[key], ...inputs },
    });
  };
